import ApplicationComponent from "legacy/ApplicationComponent"
import WarningAlert from "legacy/reports/WarningAlert"
import PropTypes from "prop-types"
import React from "react"

/**
 * SunsettingAccountingReportAlert is an alert that directs the user of sunsetting legacy reports and directs them to the new accounting reports
 * @param {string} sunsetDate - A string of the date that the legacy report will be sunsetted
 * @param {string} sunsetDateIsPast - A bool that is true if the sunsetDate is in the past
 */

class SunsettingAccountingReportAlert extends ApplicationComponent {
  render() {
    return (
      <WarningAlert>
        <span>
          {`This report ${
            this.props.sunsetDateIsPast ? "was" : "will be"
          } removed on ${
            this.props.sunsetDate
          }. Please use our new reports for an improved experience.`}
        </span>
      </WarningAlert>
    )
  }
}

SunsettingAccountingReportAlert.propTypes = {
  sunsetDate: PropTypes.string.isRequired,
  sunsetDateIsPast: PropTypes.bool.isRequired,
}

export default SunsettingAccountingReportAlert
